import { render } from "./PaymentConfirmationForm.vue?vue&type=template&id=3f85fb7a&scoped=true"
import script from "./PaymentConfirmationForm.vue?vue&type=script&lang=js"
export * from "./PaymentConfirmationForm.vue?vue&type=script&lang=js"

import "./PaymentConfirmationForm.vue?vue&type=style&index=0&id=3f85fb7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f85fb7a"]])

export default __exports__